export enum QueryParam {
  ReturnUrl = 'return_url',
  EmailAddress = 'email',
  Platform = 'platform',
}

export type EmailLinkStatus =
  | 'loading'
  | 'verified'
  | 'failed'
  | 'expired'
  | 'verifiedOnOtherDevice';
